"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _I18n = _interopRequireDefault(require("I18n"));

var _Conditions = _interopRequireDefault(require("access-control-lib/conditions/Conditions"));

var _selectors = require("settings-ui-sdk/Auth/selectors");

var _selectors2 = require("settings-ui-sdk/Routes/selectors");

var _UIRouterTab = _interopRequireDefault(require("ui-addon-react-router/UIRouterTab"));

var _UITabs = _interopRequireDefault(require("UIComponents/nav/UITabs"));

var _AccessControl = require("../../constants/AccessControl");

var _selectors3 = require("settings-ui-sdk/CanSpamSettings/selectors");

var TABS = null;

var getTabs = function getTabs() {
  if (!TABS) {
    TABS = [{
      accessControl: {
        or: [_AccessControl.COLOR_SETTINGS_READ, _AccessControl.FONT_SETTINGS_READ, _AccessControl.FOOTER_CARDS_READ, _AccessControl.RSS_DATE_FORMAT_READ, _AccessControl.SIZE_SETTINGS_READ]
      },
      className: 'email-tabs-configuration',
      id: 'configuration',
      to: 'marketing/email/configuration',
      title: _I18n.default.text('marketing.email.tabs.configuration')
    }, {
      accessControl: _AccessControl.DOUBLE_OPTIN_PANEL,
      className: 'email-tabs-double-opt-in',
      id: 'double-opt-in',
      to: 'marketing/email/double-opt-in',
      title: _I18n.default.text('marketing.email.tabs.doubleOptIn')
    }, {
      accessControl: {
        or: [_AccessControl.BCC_EMAIL_SETTINGS_READ, _AccessControl.DOUBLE_OPTIN_READ, _AccessControl.GRAYMAIL_SUPPRESSION_READ, _AccessControl.RESUBSCRIPTION_EMAIL_READ, _AccessControl.SUBSCRIPTION_PAGE_READ]
      },
      className: 'email-tabs-subscriptions',
      id: 'subscriptions',
      to: 'marketing/email/subscriptions',
      title: _I18n.default.text('marketing.email.tabs.subscriptions')
    }, {
      accessControl: _AccessControl.TYPES_READ,
      className: 'email-tabs-types',
      id: 'types',
      to: 'marketing/email/types',
      title: _I18n.default.text('marketing.email.tabs.types')
    }, {
      accessControl: _AccessControl.TRACKING_READ,
      className: 'email-tabs-tracking',
      id: 'tracking',
      to: 'marketing/email/tracking',
      title: _I18n.default.text('marketing.email.tabs.tracking')
    }, {
      accessControl: _AccessControl.SMTP_TOKENS_TAB_READ,
      className: 'email-tabs-smtp',
      id: 'smtp',
      to: 'marketing/email/smtp',
      title: _I18n.default.text('marketing.email.tabs.smtp')
    }, {
      accessControl: _AccessControl.FREQUENCY_READ,
      className: 'email-tabs-frequency',
      id: 'frequency',
      to: 'marketing/email/frequency',
      title: _I18n.default.text('marketing.email.tabs.frequency')
    }];
  }

  return TABS;
};

var TabsContainer =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(TabsContainer, _PureComponent);

  function TabsContainer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TabsContainer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TabsContainer).call(this, props));
    _this.renderTab = _this.renderTab.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TabsContainer, [{
    key: "renderTab",
    value: function renderTab(_ref) {
      var id = _ref.id,
          to = _ref.to,
          title = _ref.title,
          className = _ref.className,
          accessControl = _ref.accessControl;
      var _this$props = this.props,
          gates = _this$props.gates,
          hasCanSpamSettings = _this$props.hasCanSpamSettings,
          scopes = _this$props.scopes;
      var isDisabled = !hasCanSpamSettings && id === 'double-opt-in';
      var tooltipText = isDisabled ? _I18n.default.text('marketing.email.doi.tab.tooltip') : null;

      if (_Conditions.default.shouldAccess(accessControl)({
        gates: gates,
        scopes: scopes
      })) {
        return _react.default.createElement(_UIRouterTab.default, {
          className: className,
          disabled: isDisabled,
          key: id,
          tabId: id,
          title: title,
          to: to,
          tooltip: tooltipText
        });
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var activeTab = this.props.activeTab;
      return _react.default.createElement(_UITabs.default, {
        selected: activeTab,
        use: "enclosed",
        className: "email-tabs"
      }, getTabs().map(this.renderTab));
    }
  }]);
  return TabsContainer;
}(_react.PureComponent);

TabsContainer.propTypes = {
  activeTab: _react.PropTypes.string.isRequired,
  gates: _react.PropTypes.oneOfType([_react.PropTypes.array, _react.PropTypes.object]).isRequired,
  hasCanSpamSettings: _react.PropTypes.bool.isRequired,
  scopes: _react.PropTypes.oneOfType([_react.PropTypes.array, _react.PropTypes.object]).isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  var footers = (0, _selectors3.getCanSpamSettings)(state);
  var hasCanSpamSettings = Boolean(footers.first() && footers.first().get('company_name'));
  return {
    activeTab: (0, _selectors2.getActiveTabIdFromRoute)(state),
    gates: (0, _selectors.getUserGates)(state),
    hasCanSpamSettings: hasCanSpamSettings,
    scopes: (0, _selectors.getUserScopes)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(TabsContainer);

exports.default = _default;
module.exports = exports.default;